import React from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";

import { Text } from "@components/Text";
import { COLOR_BLACK } from "@static/COLORS";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
export const MiniPreviewStreaming = ({ path = null }) => {
  const isRtmp = path?.startsWith("rtmp://");
  const isRtsp = path?.startsWith("rtsp://");
  const isHls = !isRtmp && !isRtsp;
  // return <div>Streaming</div>;

  return (
    <React.Fragment>
      <Container>
        {isHls ? (
          <ReactPlayer
            url={path}
            controls
            width={"100%"}
            height={"100%"}
            playing
            style={{
              background: COLOR_BLACK,
            }}
          />
        ) : (
          <Text
            align="center"
            color="white"
          >{`RTMP or RTSP\nSupport android only.`}</Text>
        )}
      </Container>
    </React.Fragment>
  );
};
